var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable class-methods-use-this */
import { ConciergeChatManager } from './concierge-manager-base';
import config from '../../../config';
import { Logger } from '../../infra/observability/logger';
var SalesforceMessagingSessionsManager = /** @class */ (function (_super) {
    __extends(SalesforceMessagingSessionsManager, _super);
    function SalesforceMessagingSessionsManager() {
        var _this = _super.call(this, 'salesforce-messaging-sessions') || this;
        _this.mount = function () {
            _this.mounted = true;
            var showChatEl = function () {
                var smsChatEl = document.getElementById('embedded-messaging');
                if (smsChatEl) {
                    smsChatEl.style.display = 'block';
                }
            };
            var initEmbeddedMessaging = function () {
                try {
                    window.embeddedservice_bootstrap.settings.language = 'en_US';
                    window.embeddedservice_bootstrap.settings.chatButtonPosition = '124px,40px'; // format is 'bottom-px,right-px'
                    window.embeddedservice_bootstrap.init(config.salesforceMessagingSessionsChat.key, 'Commander_Messaging_Session', config.salesforceMessagingSessionsChat.url, {
                        scrt2URL: 'https://getsquire.my.salesforce-scrt.com',
                    });
                    showChatEl();
                }
                catch (err) {
                    Logger.error('Salesforce Messaging Sessions failed to initialize', err);
                }
            };
            var hasEmbeddedObject = !!window.embeddedservice_bootstrap;
            if (!hasEmbeddedObject) {
                return new Promise(function (resolve) {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = "".concat(config.salesforceMessagingSessionsChat.url, "/assets/js/bootstrap.min.js");
                    document.body.appendChild(script);
                    script.onload = function () {
                        initEmbeddedMessaging();
                        resolve();
                    };
                });
            }
            showChatEl();
            return Promise.resolve();
        };
        _this.open = function () {
            var _a, _b;
            var openSmsChat = (_b = (_a = window.embeddedservice_bootstrap) === null || _a === void 0 ? void 0 : _a.utilAPI) === null || _b === void 0 ? void 0 : _b.launchChat;
            if (openSmsChat) {
                openSmsChat();
            }
        };
        _this.close = function () {
            // nothing for closing chat in API...
            // https://developer.salesforce.com/docs/service/messaging-web/references/m4w-reference/overview.html
        };
        _this.unmount = function () {
            _this.mounted = false;
            _this.close();
            var smsChatEl = document.getElementById('embedded-messaging');
            if (smsChatEl) {
                smsChatEl.style.display = 'none';
            }
        };
        return _this;
    }
    return SalesforceMessagingSessionsManager;
}(ConciergeChatManager));
export { SalesforceMessagingSessionsManager };
